module.exports = __webpack_public_path__ + "img/e-order_btn_bg.ad87b8c6.png";